/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Zone_LabelInputs */



/**
* | output |
* | --- |
* | "Drag & drop your media file here" |
*
* @param {New_Project_Drop_Zone_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_zone_label = /** @type {((inputs?: New_Project_Drop_Zone_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Zone_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Glissez-déposez votre fichier multimédia ici")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziehen Sie Ihre Mediendatei per Drag & Drop hierher.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascina e rilascia qui il tuo file multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перетащите сюда свой медиафайл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arrastra y suelta tu archivo multimedia aquí.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将媒体文件拖放到此处")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルをここにドラッグ＆ドロップしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपनी मीडिया फ़ाइल को यहाँ ड्रैग और ड्रॉप करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arraste e solte seu arquivo de mídia aqui.")
	return /** @type {LocalizedString} */ ("Drag & drop your media file here")
});